import React, { useState } from 'react';
import { TextField, Button, Box, Grid, Select, InputLabel, MenuItem, FormControlLabel , RadioGroup, Radio } from '@material-ui/core';
import { FormControl } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import useStyles  from './useStyles'

import { ErrorMessage } from '@hookform/error-message'
import { format } from "../commons/utils";
import { singleInputValidator } from '../commons/utils';
import { FlashOnRounded, WallpaperTwoTone } from '@material-ui/icons';
import ReactGA from "react-ga";

const PasoDosForm = ({nombreRep, setNombreRep, rutRep, setRutRep, apellidoPRep, setApellidoPRep,
  apellidoMRep, setApellidoMRep, profesionRep, setProfesionRep, direccionRep, setDireccionRep,
  telefonoRep, setTelefonoRep, correoRep, setCorreoRep,  errors, setError, regionRep, setRegionRep, ciudadRep, setCiudadRep, nombreRegionRep, nombreProvinciaRep, comunaRep, setComunaRep, nombreComunaRep, show, setShow , generoRep, setGeneroRep, tipogenero, setSexoRep, tiposexo, sexoRep}) => {

    const classes = useStyles();

    const [subTitulo, setSubTitulo] = useState('Identificación del Representante') 
    const [pregUno, setpregUno] = React.useState(1);
    

    const handleChangeRutRep = evt => {
      setRutRep(format(evt.target.value))
    }

    const handleChangeNombreRep = evt => {
      setNombreRep(evt.target.value)
    }

    const handleChangeApellidoPRep = evt => {
      setApellidoPRep(evt.target.value)
    }

    const handleChangeApellidoMRep = evt => {
      setApellidoMRep(evt.target.value)
    }

    const handleChangeProfesionRep = evt => {
      setProfesionRep(evt.target.value)
    }

    const handleChangeDireccionRep = evt => {
      setDireccionRep(evt.target.value)
    }

    const handleChangeGenero = (event) => {
      setGeneroRep(event.target.value);
  
    };
  
    const handleChangeSexo = (event) => {
      setSexoRep(event.target.value);
  
    };

    const handleChangeTelefonoRep = evt => {
      setTelefonoRep(evt.target.value)
    }

    const handleChangeCorreoRep = evt => {
      setCorreoRep(evt.target.value)
    }

    const handleChangeRegion = (event) => {
      setRegionRep(event.target.value);
    }; 
  
  
    const handleChangeCiudad = (event) => {
      setCiudadRep(event.target.value);
    };
    const handleChangeComuna = (event) => {
      setComunaRep(event.target.value);
    };
    const printRegionRep = () => {
      return nombreRegionRep.map((item,index)=>{
        return <MenuItem  key={index} value={item.region_id}>{item.region_nombre}</MenuItem>
      })
    }
  
    const printProvinciaRep = () => {
      return nombreProvinciaRep.map((item,index)=>{
        return <MenuItem  key={index} value={item.provincia_id}>{item.provincia_nombre}</MenuItem>
      })
    }
   
    const printGeneroRep = () => {
      return tipogenero.map((item,index)=>{
        return <MenuItem  key={index} value={item.id}>{item.descripcion}</MenuItem>
      })
    }
  
    const printSexoRep = () => {
      return tiposexo.map((item,index)=>{
        return <MenuItem  key={index} value={item.id}>{item.descripcion}</MenuItem>
      })
    }
  
    const printComunaRep = () => {
      return nombreComunaRep.map((item,index)=>{
        //console.log("item", item)
        return <MenuItem  key={index} value={item.comuna_id}>{item.comuna_nombre}</MenuItem>
      })
    }
    const handleChangePregUno = evt => {
    
      if (evt.target.value === '1'  )
          setShow(true)
      
      else
          setShow(false)
          
      setpregUno(evt.target.value)
    }
    //ReactGA.pageview('/paso2');


    return (


    <>
        {/* aca va el sub titulo del formulario */}
        <Box display="flex" justifyContent="start">
          <h3 style={{ color: '#0064AC', fontSize: 16, textAlign:'left', fontWeight: 'bold', marginLeft: 45 }}>Identificación del Representante </h3>
          
        </Box>
        <h3 style={{ color: '#0064AC', fontSize: 16, textAlign:'left', marginLeft: 45 }}> ¿Es la misma persona identificada como cotizante o beneficiario?</h3>
        {/* cuerpo para inputs, puede ser mas de un grid dependiendo de las filas que se necesite */}
        

        <FormControl className={classes.formControlComponent}>
            <RadioGroup row aria-label="PregUno" name="PregUno" defaultValue="2" onChange={handleChangePregUno} >
                <FormControlLabel value="1" control={<Radio />} label="Si"  />
                <FormControlLabel value="2" control={<Radio />} label="No" />
            </RadioGroup>
        </FormControl>
        <FormControl className={classes.formControlComponent}  size="small">
        </FormControl>


     
   

        <Grid>

          <FormControl className={classes.formControlComponent} hidden={show} >
            <TextField  onChange={handleChangeRutRep} onBlur={() => singleInputValidator(rutRep,"RutRep",setError, [{option:'rutValidation', updateFields:false}])} value={rutRep} name="RutRep" id="input-id" variant="outlined" label="Rut" size="small" />
      
            <ErrorMessage
            style={{ color: 'red' }}
            name="RutRep"
            as="div"
            errors={errors}
          />
          </FormControl>

          <FormControl className={classes.formControlComponent} hidden={show} >
            <TextField  onChange={handleChangeNombreRep} onBlur={() => {
              setNombreRep(nombreRep.trim())
              singleInputValidator(nombreRep,"NombreRep",setError, [])
            }} value={nombreRep} id="input-id" variant="outlined" label="Nombre" name='NombreRep' size="small" />
            <ErrorMessage
            style={{ color: 'red' }}
            name="NombreRep"
            as="div"
            errors={errors}
          />
          </FormControl>

          <FormControl className={classes.formControlComponent} hidden={show}>
            <TextField  onChange={handleChangeApellidoPRep} onBlur={() => {
              setApellidoPRep(apellidoPRep.trim())
              singleInputValidator(apellidoPRep,"apellidoPRep",setError, [])
            }} value={apellidoPRep} name="apellidoPRep" id="input-id" variant="outlined" label="Apellido Paterno" size="small" />
            <ErrorMessage
            style={{ color: 'red' }}
            name="apellidoPRep"
            as="div"
            errors={errors}
          />
          </FormControl>

          <FormControl className={classes.formControlComponent} hidden={show}>
            <TextField  onChange={handleChangeApellidoMRep} onBlur={() => {
              setApellidoMRep(apellidoMRep.trim())
              singleInputValidator(apellidoMRep,"apellidoMRep",setError, [])
            }} value={apellidoMRep} name="apellidoMRep" id="input-id" variant="outlined" label="Apellido Materno" size="small" />
            <ErrorMessage
            style={{ color: 'red' }}
            name="apellidoMRep"
            as="div"
            errors={errors}
          />
          </FormControl>

          <FormControl className={classes.formControlComponent} size="small" hidden={show}>
         <InputLabel id="selectlabelGenero" variant="outlined" >Genero</InputLabel>
          <Select
            required
            labelId="generolabel"
            id="selectlabelGenero"
            variant="outlined"
            value={generoRep}
            label="Genero"
            onChange={handleChangeGenero}
            name="generoRep"
            
          >
            {printGeneroRep()}
          </Select>
          <ErrorMessage
            style={{ color: 'red' }}
            name="generoRep"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent} size="small" hidden={show}>
         <InputLabel id="selectlabelGenero" variant="outlined" >Sexo</InputLabel>
          <Select
            required
            labelId="generolabel"
            id="selectlabelGenero"
            variant="outlined"
            value={sexoRep}
            label="Sexo"
            onChange={handleChangeSexo}
            name="sexoRep"
            
          >
            {printSexoRep()}
          </Select>
          <ErrorMessage
            style={{ color: 'red' }}
            name="sexoRep"
            as="div"
            errors={errors}
          />
        </FormControl>


          <FormControl className={classes.formControlComponent}  size="small" hidden={show} >
            <InputLabel id="regionlabel"  variant="outlined" >Región</InputLabel>
                <Select
                required
                labelId="regionlabel"
                id="regionlabel"
                variant="outlined"
                value={regionRep}
                label="Región"
                onChange={handleChangeRegion}
          
                name="regionRep"
                >
                {printRegionRep()}
                </Select>
                <ErrorMessage
                  style={{ color: 'red' }}
                  name="regionRep"
                  as="div"
                  errors={errors}
                />
          </FormControl>

 


          <FormControl className={classes.formControlComponent}  size="small" hidden={show}>
          <InputLabel id="selectlabelComuna"  variant="outlined" >Comuna</InputLabel>
                <Select
                required
                labelId="comunalabel"
                id="selectlabelComuna"
                variant="outlined"
                value={comunaRep}
                label="Comuna"
                onChange={handleChangeComuna}
              
                name="comuna"
                >
                     {printComunaRep()}
                </Select>
                <ErrorMessage
                  style={{ color: 'red' }}
                  name="comuna"
                  as="div"
                  errors={errors}
                />
          </FormControl>

      
        <FormControl className={classes.formControlComponent} hidden={show} >
          <TextField  onChange={handleChangeDireccionRep} onBlur={() => {
            setDireccionRep(direccionRep.trim())
            singleInputValidator(direccionRep,"direccionRep",setError, [])
          }} value={direccionRep} name="direccionRep" id="input-id" variant="outlined" label="Dirección"  size="small"/>
          <ErrorMessage
            style={{ color: 'red' }}
            name="direccionRep"
            as="div"
            errors={errors}
          />
        </FormControl>


          <FormControl className={classes.formControlComponent} hidden={show} >
            <TextField  onChange={handleChangeTelefonoRep} onBlur={() => {
              setTelefonoRep(telefonoRep.trim())
              singleInputValidator(telefonoRep,"telefonoRep",setError, [])
            }} value={telefonoRep} name="telefonoRep" id="input-id" variant="outlined"  type="number" label="Teléfono" size="small" />
            <ErrorMessage
            style={{ color: 'red' }}
            name="telefonoRep"
            as="div"
            errors={errors}
          />
          </FormControl>



          <FormControl className={classes.formControlComponent} hidden={show}>
            <TextField  onChange={handleChangeCorreoRep} onBlur={() => {
              setCorreoRep(correoRep.trim())
              singleInputValidator(correoRep,"correoRep",setError, [{option:'eMail'}])
            }} value={correoRep} name="correoRep" id="input-id" variant="outlined" label="Correo" size="small" />   
            <ErrorMessage
            style={{ color: 'red' }}
            name="correoRep"
            as="div"
            errors={errors}
          />
          </FormControl>

     
          </Grid>
      </>




  )
}

export default PasoDosForm